import { createFileRoute } from '@tanstack/react-router';
import { McpConnectPage } from '../features/mcp/connect-page';

export const Route = createFileRoute('/account/mcp/')({
  component: McpConnectPage,
});
